import { resolve, type SelectionAttributes } from "@otto-ec/nexus-registry/selection";
import { isMobile } from "../util/Breakpoint";
import { heureka } from "@otto-ec/heureka";
import { isActive } from "../toggle/Toggle";
import { hcSheetState } from "../hcSheet/hcSheetState.svelte";

export type MergeFn = (changes: SelectionAttributes[]) => SelectionAttributes;
type Handler = (attributes: SelectionAttributes) => unknown;

/*                                                */
let accumulated: SelectionAttributes[] = [];

export async function resolvePreview(attributes: SelectionAttributes) {
  heureka.dresonRule_resolve.emit();
  const { selection } = await resolve({ attributes }, { commit: false });
  heureka.dresonRule_resolved.emit(selection);
}

/**
 *
 *
 *
 *
 */
export function accumulateOnMobile(f: Handler, alternative: Handler): Handler {
  if (isMobile()) {
    return (attributes: SelectionAttributes) => {
      if (isActive("HEUREKA_2349_BATCH_DRESONRULE_ON_MOBILE") && hcSheetState.open) {
        accumulated.push(attributes);
        return alternative(attributes);
      } else {
        return f(attributes);
      }
    };
  } else {
    return f;
  }
}

/**
 *
 *
 *
 *
 */
export function submitAccumulated(f: Handler, mergeFn: MergeFn) {
  if (accumulated.length === 0) return;
  const merged = mergeFn(accumulated);
  accumulated = [];
  return f(merged);
}
